import React from 'react';
import { FormControl, Select, MenuItem, FormHelperText } from '@mui/material';

const SelectField = React.forwardRef(({ options, error, helperText, ...props }, ref) => {
  return (
    <FormControl fullWidth error={error}>
      <Select
        {...props}
        ref={ref}
        displayEmpty
        sx={{
          backgroundColor: 'white',
          '& .MuiSelect-select': {
            p: 1.5
          }
        }}
      >
        <MenuItem value="" disabled>
          Select
        </MenuItem>
        {options.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
      {error && helperText && (
        <FormHelperText>{helperText}</FormHelperText>
      )}
    </FormControl>
  );
});

export default SelectField;